export default function managePreviewRedirects(
  Authentication,
  transition,
  premiumFeature,
  stateBase,
  defaultSubstate,
  employeeFallbackState = '404'
) {
  const redirectOpts = [null, { location: 'replace' }];
  const targetState = transition.$to().name;

  if (!Authentication.isOrgFeatureEnabled(premiumFeature)) {
    if (Authentication.user.isManager && targetState !== `${stateBase}.preview`) {
      return transition.router.stateService.target(`${stateBase}.preview`, ...redirectOpts);
    }

    if (!Authentication.user.isManager && targetState !== employeeFallbackState) {
      return transition.router.stateService.target(employeeFallbackState, ...redirectOpts);
    }
  }

  if (
    targetState === stateBase ||
    (Authentication.isOrgFeatureEnabled(premiumFeature) && targetState === `${stateBase}.preview`)
  ) {
    return transition.router.stateService.target(defaultSubstate, ...redirectOpts);
  }
}
